import styled from 'styled-components';
import { TextField } from '@material-ui/core';

import appTheme from '../../../themes/Theme';
import { Color } from '../../../constants/Color';

export const StyledTextField = styled(TextField)`
  label.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated {
    color: ${appTheme.labelTextField};
  }

  .MuiInputBase-root {
    color: ${appTheme.textColor};
  }

  .MuiInput-underline:before {
    border-color: ${Color.PuertoRico};
  }

  .MuiInput-underline:hover {
    &::before {
      border-color: ${Color.PuertoRico};
    }
  }

  .MuiInput-underline:after {
    border-color: ${Color.PuertoRico};
    border-width: 1px;
  }
`;
